// What the yearbook landing page (/c/yearbooks?sch=&sid=&campaign=&message_id=&from=)
// showed, for the funnel log's yearbook_viewed event. Pure, so the three
// outcomes can be tested without rendering the page.

// The price per yearbook the in-window form shows AND puts on the order
// package: the school's own price when one exists, else the generic one.
// YearbookForm's memo calls this, so the price logged is the price charged.
// Unchanged from the memo it came out of, including throwing when the package
// has no price at all -- callers that must not throw guard it themselves.
export const yearbookPrice = (yearbook) => {
  if (!yearbook) return 0;

  const prices = yearbook.options.map((option) => option.prices).flat();

  const schoolPrice = prices.find((price) => price.schoolId);

  if (schoolPrice) return schoolPrice.price;

  const genericPrice = prices.find((price) => price.price);

  return genericPrice.price;
};

export const YEARBOOK_VIEW_STATES = Object.freeze({
  PRICE_AVAILABLE: 'price_available', // in the ship-to-school window: YearbookForm
  SHIP_TO_HOME: 'ship_to_home', // window over, home delivery open: YearbookHomeForm
  DEADLINE_PASSED: 'deadline_passed', // neither: "The deadline ... has passed"
});

const safePrice = (fn) => {
  try {
    const price = Number(fn());
    return Number.isFinite(price) ? price : undefined;
  } catch (e) {
    return undefined;
  }
};

// The event to record for the page's current render, or null while it is still
// loading (or never found a student). Mirrors the page's own branch order:
//   student && yearbook                  -> price available
//   still fetching the package / home    -> null (spinner)
//   homeDelivery.state === 'home'        -> ship to home
//   anything else                        -> deadline passed
export const yearbookViewEvent = ({
  student, yearbook, packageDone, homeFetching, homeDelivery,
}) => {
  if (!student) return null;

  if (yearbook) {
    return {
      state: YEARBOOK_VIEW_STATES.PRICE_AVAILABLE,
      packageId: yearbook.id,
      price: safePrice(() => yearbookPrice(yearbook)),
    };
  }

  if (!packageDone || homeFetching) return null;

  if (homeDelivery && homeDelivery.state === 'home') {
    return {
      state: YEARBOOK_VIEW_STATES.SHIP_TO_HOME,
      packageId: homeDelivery.package && homeDelivery.package.id,
      price: safePrice(() => homeDelivery.package.home_price),
    };
  }

  return { state: YEARBOOK_VIEW_STATES.DEADLINE_PASSED, homeDeliveryState: homeDelivery && homeDelivery.state };
};

export default yearbookViewEvent;
